// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/silicone-spring-as-brake-element/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSiliconeSpringAsBrakeElementEN: PageEntry = {
  id: "example.produkte-silikonfeder-als-bremselement",
  locale: "en",
  slug: "produkte/silicone-spring-as-brake-element",
  seo: {
    title: "Silicone spring as brake element | Dietz GmbH",
    description: "Special haptics when moving from the air vent in the interior area Attractive haptics independent of external temperature influences during actuation. An inseparable combination of",
  },
  type: "post",
  h1: "Silicone spring as brake element",
  intro: "Special haptics when moving from the air vent in the interior area Attractive haptics independent of external temperature influences during actuation. An inseparable combination of silicone and stamped and formed parts has been implemented. Manufacturing in a fully automated production line",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_hybrid_silikonfedern.jpg", alt: "Silicone spring as brake element", width: 1400, height: 1120 }
  ],
};
